export default function RoutePlannerTab(props) {
  const {
    draftOrigin,
    draftDestination,
    createDistance,
    number,
    createMode,
    onStartRoutePlanning,
    onClearDraftRoute,
    selectedAirport,
    onUseAirportAsStart,
    selectedPlaneId,
    onSelectPlane,
    freePlanes,
    selectedPlane,
    routePreview,
    routePreviewRange,
    routePreviewDifficulty,
    routeAdvice,
    canCreateRoute,
    onCreateRoute,
    money
  } = props;

  return (
    <div className="tabContent">
      <div className="sectionTitle">
        <div>
          <h2>Nová linka</h2>
          <p>
            {draftOrigin && draftDestination
              ? `${draftOrigin.iata || draftOrigin.icao} ⇄ ${draftDestination.iata || draftDestination.icao} · ${number(createDistance)} km`
              : "Klikni na „Vytvořit novou linku“ a potom na letiště na mapě."}
          </p>
        </div>
      </div>

      <div className={createMode ? "planner active" : "planner"}>
        <button className="primary compactBtn" onClick={function () { onStartRoutePlanning(); }}>
          Vytvořit novou linku
        </button>
        <div>
          <strong>{createMode ? "Režim výběru je zapnutý" : "Režim výběru je vypnutý"}</strong>
          <span>
            {!createMode
              ? "Po zapnutí klikni na letiště a v dialogu si vyber, jestli má být startovní nebo cílové."
              : "Klikni na letiště a vyber jeho roli v trase."}
          </span>
        </div>
        {(draftOrigin || draftDestination || createMode) && <button onClick={onClearDraftRoute}>Vymazat výběr</button>}
      </div>

      <div className="routeDraftBox">
        <div>
          <span>Start</span>
          <strong>{draftOrigin ? `${draftOrigin.iata || draftOrigin.icao} · ${draftOrigin.name}` : "nevybráno"}</strong>
        </div>
        <div>
          <span>Cíl</span>
          <strong>{draftDestination ? `${draftDestination.iata || draftDestination.icao} · ${draftDestination.name}` : "nevybráno"}</strong>
        </div>
      </div>

      {selectedAirport && !createMode && (
        <div className="selectedAirport">
          <div>
            <strong>{selectedAirport.iata || selectedAirport.icao}</strong>
            <span>{selectedAirport.name}</span>
          </div>
          <button onClick={function () { onUseAirportAsStart(selectedAirport); }}>Použít jako start</button>
        </div>
      )}

      <label>
        Letadlo
        <select value={selectedPlaneId} onChange={function (event) { onSelectPlane(event.target.value); }}>
          <option value="">Vyber volné letadlo</option>
          {freePlanes.map(function (plane) {
            return (
              <option key={plane.id} value={plane.id}>
                {plane.model} · {plane.seats} míst · dolet {number(plane.range)} km
              </option>
            );
          })}
        </select>
      </label>

      {selectedPlane && draftOrigin && draftDestination && (
        <div className={createDistance <= selectedPlane.range ? "routeCheck ok" : "routeCheck bad"}>
          {createDistance <= selectedPlane.range ? "Dolet je v pořádku." : `Letadlo nedoletí. Chybí ${number(createDistance - selectedPlane.range)} km.`}
        </div>
      )}

      {selectedPlane && routePreview && routePreviewDifficulty && (
        <div className="routePreview">
          <div className="previewHeader">
            <div>
              <strong>{selectedPlane.model}</strong>
              <span>{number(createDistance)} km · využití doletu {Math.round((createDistance / selectedPlane.range) * 100)}%</span>
            </div>
            <em className={routePreviewDifficulty.className}>{routePreviewDifficulty.label}</em>
          </div>
          <div className="statGrid">
            <span><b>{money(routePreview.oneFlight.profit)}</b><em>zisk po jednom doletu</em></span>
            <span><b>{routePreviewRange ? `${money(routePreviewRange.low.oneFlight.profit)} až ${money(routePreviewRange.high.oneFlight.profit)}` : "-"}</b><em>let při 80–100 %</em></span>
            <span><b>{money(routePreview.oneFlight.costs)}</b><em>náklady letu</em></span>
            <span><b>{routePreview.oneFlight.passengers}</b><em>cestující při 90 %</em></span>
            <span><b>{routePreview.flightsPerDay.toFixed(1)}×</b><em>letů za den</em></span>
            <span><b>{money(routePreview.profit)}</b><em>odhad za den</em></span>
          </div>
          <p>{routeAdvice(createDistance, selectedPlane, routePreview)}</p>
        </div>
      )}

      <button className="primary" disabled={!canCreateRoute} onClick={onCreateRoute}>Spustit linku</button>
    </div>
  );
}
